export default __webpack_public_path__ + "static/media/shoe1.51aa0b51.webp";